<template>
    <v-container
        fluid
        v-if="
            contractEdit == true &&
            (contract.contract_type_id == 2 ||
                contract.contract_type_id == 4 ||
                contract.contract_type_id == 5 ||
                contract.contract_type_id == 6)
        "
    >
        <v-row>
            <v-col class="pl-5">
                <v-btn
                    v-if="inEditMode && contract.id != null"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="saveClick(null)"
                >
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
            <v-col class="text-right">
                <v-btn class="mr-2" @click="saveDraft" v-if="contract.id == null">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveDraft') }}
                </v-btn>
                <v-btn
                    @click="confirmContract"
                    color="primary"
                    v-if="contract.contract_status_id == 3 || this.contract.id == null"
                >
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.confirmContract') }}
                </v-btn>
                <v-btn
                    @click="cancelContract"
                    v-if="contract.id != null && contract.contract_status_id == 2"
                    color="secondary"
                >
                    <v-icon small>fa-ban</v-icon>&nbsp;{{ $t('buttons.cancelContract') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="3">
                                <DatePicker
                                    :readonly="!inEditMode && contract.id != null"
                                    v-model="contract.effective_from"
                                    :errorBorder="!contractValidation.effective_from"
                                    :date-label="$t('fields.effectiveFrom')"
                                    @input="contract.properties.for_specified_period_from = contract.effective_from"
                                ></DatePicker>
                            </v-col>
                            <v-col cols="3" v-show="contract.contract_status_id == 5">
                                <DatePicker
                                    :readonly="true"
                                    v-model="contract.effective_to"
                                    :errorBorder="!contractValidation.effective_to"
                                    :date-label="$t('fields.effectiveTo')"
                                ></DatePicker>
                            </v-col>
                            <v-col cols="3" v-show="contract.contract_status_id == 1 || contract.id == null">
                                <DatePicker
                                    :readonly="!inEditMode"
                                    v-model="contract.notify_for_extension"
                                    :date-label="$t('fields.notifyForExtension')"
                                    @input="contract.properties.for_specified_period_to = contract.notify_for_extension"
                                ></DatePicker>
                            </v-col>
                            <v-col cols="3" class="pl-8">
                                <Dropdown
                                    :readonly="true"
                                    v-model="contract.contract_status_id"
                                    :ajax="true"
                                    :data="'contract-statuses'"
                                    :errorBorder="!contractValidation.contract_status_id"
                                    :label="'* ' + $t('fields.status')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="1" v-if="contract.id != null">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{on, attrs}">
                                        <v-btn
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            class="pt-0 mt-0"
                                            @click="downloadOriginal"
                                        >
                                            <v-icon large>fas fa-download</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('tooltips.downloadOriginal') }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="2" v-show="contract.id != null">
                                <Upload
                                    :readonly="!inEditMode && contract.id != null"
                                    v-model="contract.file"
                                    :errorBorder="!contractValidation.file"
                                    :key="componentKey"
                                ></Upload>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-radio-group :readonly="!inEditMode" v-model="contract.properties.new_alteration" row>
                                <v-radio :label="$t('buttons.new')" :value="'New'" color="primary"></v-radio>
                                <v-radio
                                    :label="$t('buttons.alteration')"
                                    :value="'Alteration'"
                                    color="primary"
                                ></v-radio>
                            </v-radio-group>
                        </v-row>
                    </v-card-text> </v-card
            ></v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.seafarer') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.surname"
                                    :label="'* ' + $t('fields.lastName')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.name"
                                    :label="'* ' + $t('fields.name')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.birth_number"
                                    :label="'* ' + $t('fields.birthNumber')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.place_of_birth"
                                    :label="'* ' + $t('fields.placeOfBirth')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.nationality"
                                    :label="'* ' + $t('fields.nationality')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.home_address"
                                    :label="'* ' + $t('fields.homeAddress')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.phone"
                                    :label="'* ' + $t('fields.phone')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="true"
                                    v-model="contract.properties.next_of_kin_info"
                                    :label="'* ' + $t('fields.nextOfKinNameAddressPhone')"
                                ></TextArea>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown
                                    v-if="contract.properties.employer_id != null"
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.employer_id"
                                    :ajax="true"
                                    :data="'entities'"
                                    :label="'* ' + $t('fields.employer')"
                                ></Dropdown>
                                <Dropdown
                                    v-else
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.internal_office_id"
                                    :ajax="true"
                                    :data="'internal-offices'"
                                    :label="'* ' + $t('fields.employer')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.organisation_reg_number"
                                    :label="'* ' + $t('fields.organisationRegNumber')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12" v-if="isNsaV2">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.employer_phone"
                                    :label="$t('fields.employerPhone')"
                                ></InputField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.toBeCompletedOnlyInCaseOfTemporaryEmployment') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.vessel"
                                    :label="'* ' + $t('fields.vessel')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">{{ $t('labels.forSpecifiedPeriod') }}</v-col>
                            <v-col cols="6">
                                <DatePicker
                                    :readonly="true"
                                    v-model="contract.properties.for_specified_period_from"
                                    :date-label="$t('fields.from')"
                                ></DatePicker>
                            </v-col>
                            <v-col cols="6">
                                <DatePicker
                                    :readonly="true"
                                    v-model="contract.properties.for_specified_period_to"
                                    :date-label="$t('fields.to')"
                                ></DatePicker>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.one_specific_voyage_and_possible_duration"
                                    :label="'* ' + $t('fields.oneSpecificVoyageAndPossibleDuration')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.substitue_for"
                                    :label="'* ' + $t('fields.substitueFor')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.temporary_employment"
                                    :label="'* ' + $t('fields.temporaryEmployment')"
                                ></InputField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.termsOfEmployment') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12">{{ $t('labels.wagesOvertimePayAndOtherConditions') }}</v-col>
                            <v-col cols="5">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.wages_overtime_pay"
                                ></InputField>
                            </v-col>
                            <v-col cols="2">{{ $t('labels.and') }}</v-col>
                            <v-col cols="6">
                                <InputField :readonly="!inEditMode" v-model="contract.properties.and"></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.paid_annual_leave_or_formula"
                                    :label="'* ' + $t('fields.paidAnnuaLleaveOrFormula')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.health_and_social_security_protection_benefits"
                                    :label="'* ' + $t('fields.healthAndSocialSecurityProtectionBenefits')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.entitlement_to_reparation"
                                    :label="'* ' + $t('fields.entitlementToReparation')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!true"
                                    v-model="contract.properties.special_conditions_other_information"
                                    :label="'* ' + $t('fields.specialConditionsOtherInformation')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="true"
                                    v-model="contract.properties.rank_id"
                                    :ajax="true"
                                    :data="'ranks'"
                                    :label="'* ' + $t('fields.rank')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.seniority"
                                    :label="'* ' + $t('fields.seniority')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.wages_from_and_including"
                                    :label="'* ' + $t('fields.wagesFromAndIncluding')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.possible_place_of_terminating_service"
                                    :label="'* ' + $t('fields.possiblePlaceOTerminatingService')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="contract.properties.probationary_period"
                                    :label="
                                        '* ' +
                                        (isNsaV2
                                            ? $t('fields.probationaryPeriodDurationAndConditions')
                                            : $t('fields.probationaryPeriod'))
                                    "
                                ></InputField>
                            </v-col>
                            <template v-if="isNsaV2">
                                <v-col cols="12">
                                    <InputField
                                        :readonly="true"
                                        v-model="contract.properties.termination_procedure"
                                        :label="'* ' + $t('fields.terminationProcedure')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :readonly="true"
                                        v-model="contract.properties.normal_working_day_and_week"
                                        :label="'* ' + $t('fields.normalWorkingDayAndWeek')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :readonly="true"
                                        v-model="contract.properties.entitlement_to_competence"
                                        :label="'* ' + $t('fields.entitlementToCompetence')"
                                    ></InputField>
                                </v-col>
                                <v-col cols="12">
                                    <InputField
                                        :readonly="true"
                                        v-model="contract.properties.other_leave"
                                        :label="'* ' + $t('fields.otherLeave')"
                                    ></InputField>
                                </v-col>
                            </template>
                            <v-col cols="12" v-else>
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.mutual_period_of_notice"
                                    :label="'* ' + $t('fields.mutualPeriodOfNotice')"
                                ></InputField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.wageInformation') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="10">
                                <TextArea :readonly="true" v-model="contract.properties.wage_information"></TextArea>
                                <v-col cols="2" v-if="$myStore.state.user.user_role_id == 1">
                                    <v-btn class="ml-2 mr-2" color="primary" @click="feeInformation()">
                                        {{ $t('buttons.agencyFeeInformation') }}
                                    </v-btn>
                                </v-col>
                                <v-col cols="2" v-else></v-col>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="4" v-if="contract.properties.full != 0">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.full"
                                    :label="$t('fields.fullDay')"
                                ></InputField>
                            </v-col>
                            <v-col
                                cols="8"
                                class="pt-0"
                                v-if="contract.properties.fee_type_id == 1 && contract.properties.full != 0"
                            >
                                <CheckBox
                                    :readonly="true"
                                    v-model="contract.properties.full_day_fee"
                                    :label="$t('fields.agencyFee')"
                                ></CheckBox>
                            </v-col>
                            <v-col
                                cols="8"
                                v-if="contract.properties.fee_type_id != 1 && contract.properties.full != 0"
                            ></v-col>
                            <v-col cols="4" v-if="contract.properties.sick != 0">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.sick"
                                    :label="$t('fields.sickDay')"
                                ></InputField>
                            </v-col>
                            <v-col
                                cols="8"
                                class="pt-0"
                                v-if="contract.properties.fee_type_id == 1 && contract.properties.sick != 0"
                            >
                                <CheckBox
                                    :readonly="true"
                                    v-model="contract.properties.sick_day_fee"
                                    :label="$t('fields.agencyFee')"
                                ></CheckBox>
                            </v-col>
                            <v-col
                                cols="8"
                                v-if="contract.properties.fee_type_id != 1 && contract.properties.sick != 0"
                            ></v-col>
                            <v-col cols="4" v-if="contract.properties.travel != 0">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.travel"
                                    :label="$t('fields.travelDay')"
                                ></InputField>
                            </v-col>
                            <v-col
                                cols="8"
                                class="pt-0"
                                v-if="contract.properties.fee_type_id == 1 && contract.properties.travel != 0"
                            >
                                <CheckBox
                                    :readonly="true"
                                    v-model="contract.properties.travel_day_fee"
                                    :label="$t('fields.agencyFee')"
                                ></CheckBox>
                            </v-col>
                            <v-col
                                cols="8"
                                v-if="contract.properties.fee_type_id != 1 && contract.properties.travel != 0"
                            ></v-col>
                            <v-col cols="4" v-if="contract.properties.training != 0">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.training"
                                    :label="$t('fields.trainingDay')"
                                ></InputField>
                            </v-col>
                            <v-col
                                cols="8"
                                class="pt-0"
                                v-if="contract.properties.fee_type_id == 1 && contract.properties.training != 0"
                            >
                                <CheckBox
                                    :readonly="true"
                                    v-model="contract.properties.training_day_fee"
                                    :label="$t('fields.agencyFee')"
                                ></CheckBox>
                            </v-col>
                            <v-col
                                cols="8"
                                v-if="contract.properties.fee_type_id != 1 && contract.properties.training != 0"
                            ></v-col>
                            <v-col cols="4" v-if="contract.properties.quarantine != 0">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.quarantine"
                                    :label="$t('fields.quarantineDay')"
                                ></InputField>
                            </v-col>
                            <v-col
                                cols="8"
                                class="pt-0"
                                v-if="contract.properties.fee_type_id == 1 && contract.properties.quarantine != 0"
                            >
                                <CheckBox
                                    :readonly="true"
                                    v-model="contract.properties.quarantine_day_fee"
                                    :label="$t('fields.agencyFee')"
                                ></CheckBox>
                            </v-col>
                            <v-col
                                cols="8"
                                v-if="contract.properties.fee_type_id != 1 && contract.properties.quarantine != 0"
                            ></v-col>
                            <v-col cols="4" v-if="contract.properties.standby != 0">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.standby"
                                    :label="$t('fields.standbyDay')"
                                ></InputField>
                            </v-col>
                            <v-col
                                cols="8"
                                class="pt-0"
                                v-if="contract.properties.fee_type_id == 1 && contract.properties.standby != 0"
                            >
                                <CheckBox
                                    :readonly="true"
                                    v-model="contract.properties.stand_by_day_fee"
                                    :label="$t('fields.agencyFee')"
                                ></CheckBox>
                            </v-col>
                            <v-col
                                cols="8"
                                v-if="contract.properties.fee_type_id != 1 && contract.properties.other != 0"
                            ></v-col>
                            <v-col cols="4" v-if="contract.properties.other != 0">
                                <InputField
                                    :readonly="true"
                                    v-model="contract.properties.other"
                                    :label="$t('fields.otherDay')"
                                ></InputField>
                            </v-col>
                            <v-col
                                cols="8"
                                class="pt-0"
                                v-if="contract.properties.fee_type_id == 1 && contract.properties.other != 0"
                            >
                                <CheckBox
                                    :readonly="true"
                                    v-model="contract.properties.other_day_fee"
                                    :label="$t('fields.agencyFee')"
                                ></CheckBox>
                            </v-col>
                            <v-col
                                cols="8"
                                v-if="contract.properties.fee_type_id != 1 && contract.properties.other != 0"
                            ></v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import DatePicker from '@/components/trinkets/DatePicker';
import InputField from './trinkets/InputField';
import TextArea from '@/components/trinkets/TextArea';
import Contract from '../models/Contract';
import Upload from '@/components/trinkets/Upload';

export default {
    name: 'PlacementNorwegianContract',
    components: {CheckBox, DatePicker, Dropdown, InputField, TextArea, Upload},
    data: function () {
        return {
            componentKey: 0,
            contract: new Contract({}),
            contractValidation: new Contract({}, true),
            lockKey: 'contract',
            lockTimer: null,
        };
    },
    props: ['currentContract', 'contractEdit', 'placement', 'inEditMode'],
    computed: {
        // NMA-NSA ugovor na novom predlošku (30 rubrika)
        isNsaV2() {
            return this.contract.contract_type_id == 4 && this.contract.properties.template_version >= 2;
        },
    },
    methods: {
        downloadOriginal() {
            this.$APICall('post', 'download-contract-original/' + this.contract.id, {}, (data, success) => {
                if (success) {
                    window.open(data.contract_link);
                }
            });
        },
        cancelContract() {
            let vm = this;
            this.$verify(this.$t('alerts.cancelContractAlert'), (result) => {
                if (result) {
                    vm.contract.contract_status_id = 4;
                    vm.saveClick();
                }
            });
        },
        feeInformation() {
            this.$alert(this.contract.properties.agency_fee);
        },
        saveDraft() {
            this.contract.contract_status_id = 3;
            this.saveClick();
        },
        confirmContract() {
            let vm = this;
            let placementId = this.placement.id;
            let effectiveFrom = this.contract.effective_from;
            this.$APICall('get', 'placements-docs-check-for-contract/' + this.placement.id, {}, (data, succes) => {
                if (succes) {
                    let response = data.response_id;
                    if (response == 1) {
                        let verifyMessage = vm.$t('alerts.hasUnapprovedDocsQuestion');
                        vm.$verify(verifyMessage, (result) => {
                            if (result) {
                                vm.$APICall(
                                    'post',
                                    'confirm-contract/' + vm.placement.seafarer_id,
                                    {placementId, effectiveFrom},
                                    (data, succes) => {
                                        if (succes) {
                                            let response = data.response_id;
                                            if (response == 1) {
                                                let verifyMessage =
                                                    vm.$t('alerts.activeContractCurrentPlacementStart') +
                                                    vm.contract.effective_from +
                                                    vm.$t('alerts.activeContractCurrentPlacementEnding');
                                                vm.$verify(verifyMessage, (result) => {
                                                    if (result) {
                                                        vm.contract.contract_status_id = 2;
                                                        vm.saveClick();
                                                    }
                                                });
                                            } else if (response == 2) {
                                                let alertMessage =
                                                    vm.$t('alerts.activeContractAnotherPlacementStart') +
                                                    data.placement_id +
                                                    vm.$t('alerts.activeContractAnotherPlacementEnding');
                                                vm.$alert(alertMessage);
                                            } else if (response == 3) {
                                                let alertMessage =
                                                    vm.$t('alerts.cannotCreateContractOnThisDateStart') +
                                                    data.next_date;
                                                vm.$alert(alertMessage);
                                            } else {
                                                vm.contract.contract_status_id = 2;
                                                vm.saveClick();
                                            }
                                        }
                                    },
                                );
                            }
                        });
                    } else {
                        vm.$APICall(
                            'post',
                            'confirm-contract/' + vm.placement.seafarer_id,
                            {placementId, effectiveFrom},
                            (data, succes) => {
                                if (succes) {
                                    let response = data.response_id;
                                    if (response == 1) {
                                        let verifyMessage =
                                            vm.$t('alerts.activeContractCurrentPlacementStart') +
                                            vm.contract.effective_from +
                                            vm.$t('alerts.activeContractCurrentPlacementEnding');
                                        vm.$verify(verifyMessage, (result) => {
                                            if (result) {
                                                vm.contract.contract_status_id = 2;
                                                vm.saveClick();
                                            }
                                        });
                                    } else if (response == 2) {
                                        let alertMessage =
                                            vm.$t('alerts.activeContractAnotherPlacementStart') +
                                            data.placement_id +
                                            vm.$t('alerts.activeContractAnotherPlacementEnding');
                                        vm.$alert(alertMessage);
                                    } else if (response == 3) {
                                        let alertMessage =
                                            vm.$t('alerts.cannotCreateContractOnThisDateStart') + data.next_date;
                                        vm.$alert(alertMessage);
                                    } else {
                                        vm.contract.contract_status_id = 2;
                                        vm.saveClick();
                                    }
                                }
                            },
                        );
                    }
                }
            });
        },
        editClick() {
            this.$emit('edit');
        },
        backClick() {
            if (this.inEditMode) {
                let vm = this;
                this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                    if (result) {
                        vm.$emit('close-edit');
                        vm.$emit('edit-remove');
                    }
                });
            } else {
                this.$emit('close-edit');
            }
        },
        saveClick() {
            let success = true;
            let missingFields = '';

            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.contract.id != null) {
                    action = 'put';
                    addition = '/' + vm.contract.id;
                }
                this.$APICall(action, 'contracts' + addition, this.contract, (data, success) => {
                    if (success) {
                        if (vm.contract.id == null) {
                            window.open(data.contract_link);
                        }
                        if (this.contract.id != 0) {
                            vm.inEditMode = false;
                            if (vm.contract.id == 0) {
                                vm.$notify(vm.$t('alerts.basicAdd'));
                            } else {
                                vm.$notify(vm.$t('alerts.basicUpdate'));
                            }
                        }
                        vm.$emit('close-edit');
                        vm.$emit('edit-remove');
                    } else {
                        vm.$notify(vm.$t('alerts.basicError'));
                    }
                });
            } else {
                let alert = 'Missing fields: <br/> ' + missingFields;
                this.$alert(alert);
            }
        },
    },

    watch: {
        currentContract: {
            handler: function () {
                if (this.currentContract != null) {
                    this.contract = JSON.parse(JSON.stringify(this.currentContract));
                    if (this.contract.id == 0 || this.contract.id == null) {
                        this.inEditMode = true;
                    } else {
                        this.inEditMode = false;
                    }
                }
            },
            deep: true,
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    this.$removeLock(this, this.lockKey + '|' + this.contract.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
    },
};
</script>

<style scoped></style>
